// extracted by mini-css-extract-plugin
export default {"link":"profileButton-module__link--TI15z","svg":"profileButton-module__svg--k_l5v"};